import { cx, hoc, sections } from '#packages/util';
import React, { type FC } from 'react';
import { createSelector } from '../../../selectors/selector';
import { editorAPISel } from '../../selectors/rootSelectors';
import { translate } from '#packages/i18n';
import { mapDispatchToProps } from './mobileOptimizedTeaserMapper';
import styles from './mobileOptimizedTeaser.scss';

import type { EditorAPI } from '#packages/editorAPI';
import type { MobileOptimizedTeaserDispatchProps } from './mobileOptimizedTeaserMapper';

interface MobileOptimizedTeaserProps
  extends MobileOptimizedTeaserDispatchProps {}

const MobileOptimizedTeaser: FC<MobileOptimizedTeaserProps> = ({
  openEditorModePanel,
}) => {
  return (
    <div
      key="teaser"
      className={cx(styles.mobileOptimizedTeaser, {
        [styles.mobileOptimizedTeaserSectionsExperience]:
          sections.isSectionsEnabled(),
      })}
    >
      <h1>{translate('mobile_view_notification_title')}</h1>
      {translate('mobile_view_notification_text')}
      &nbsp;
      <a onClick={openEditorModePanel}>
        {translate('mobile_view_notification_text_link')}
      </a>
      &nbsp;
      {translate('mobile_view_notification_text2')}
    </div>
  );
};

const shouldShowMobileOptimizedTeaser = createSelector(
  [editorAPISel],
  (editorAPI: EditorAPI) =>
    editorAPI.isMobileEditor() &&
    !editorAPI.isMobileOptimizedSite() &&
    !editorAPI.zoomMode.isInZoomMode(),
);

const MobileOptimizedTeaserConnected = hoc.connect(
  hoc.STORES.EDITOR_API,
  null,
  mapDispatchToProps,
)(MobileOptimizedTeaser);

export default hoc.withConditionalRender(
  hoc.STORES.EDITOR_API,
  shouldShowMobileOptimizedTeaser,
)(MobileOptimizedTeaserConnected);
